<nav class="app-topbar navbar navbar-expand-xl navbar-dark fixed-top">
  <div class="app-topbar-inner container-fluid">

    <a class="app-topbar-brand navbar-brand" routerLink="/planner">
      <div class="brand-rg">
        <img src="assets/images/logo-rg-36-white.svg" alt="Renault Group" class="logo-img" />
        <span class="visually-hidden">Renault Group</span>
      </div>
      <span class="brand-title">DSP Planner</span>
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="false" aria-label="Alternar navegación">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarMain">
      <ul class="app-topbar-nav navbar-nav me-auto mb-0">
        @for (item of menuItems(); track item.route) {
        <li class="nav-item">
          <a class="app-topbar-link nav-link" [routerLink]="[item.route]" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: false }">
            @if (item.icon) {
            <span class="app-topbar-link-icon" [attr.data-icon]="item.icon" aria-hidden="true"></span>
            }
            {{ item.label }}
          </a>
        </li>
        }
      </ul>

      <div class="app-topbar-actions navbar-right">
        <button class="btn-chat" type="button" title="Chat" (click)="openChat()">
          <span class="btn-chat-icon" aria-hidden="true"></span>
          @if (unreadRoomsCount() > 0) {
          <span class="btn-chat-badge">{{ unreadRoomsCount() }}</span>
          }
          <span class="visually-hidden">Chat</span>
        </button>
        <app-distributor-common-filter variant="topbar" [resettable]="false" [selectOnChange]="true" [hideResetFilter]="true" [hideDr]="true" [hideSector]="true" [hideVnPlate]="true" [hidePvGroup]="true" [hideSectionPv]="true" [idBrand]="0" [inputFilter]="inputFilter" (modelFilterEmit)="getDistributorFilter($event)" (modelInputFilterEmit)="getDistributorInputFilter($event)">
        </app-distributor-common-filter>
        <div class="app-topbar-user">
          <span class="app-topbar-user-icon" aria-hidden="true"></span>
          <span class="user-name">{{ userName() }}</span>
          <button class="btn-logout" type="button" title="Cerrar sesión" (click)="logout()">
            <span class="btn-logout-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Cerrar sesión</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>

<main class="app-main">
  <router-outlet />
</main>